import fetchCommerceToolsGraphQLApi from "../fetchCommerceToolsGraphQLApi"
import formatDeliveryOption from "@secureo/common/utils/commerceTools/formatters/formatDeliveryOption"
import getAllDeliveryOptionSkusForLineItems from "@secureo/common/utils/commerceTools/getAllDeliveryOptionSkusForLineItems"

import { LineItem } from "@secureo/common/typings/Cart"
import { Attribute } from "@secureo/common/typings/generated/commercetools-graphql"

export interface CommerceToolsDeliveryOption {
	id: string
	key: string
	masterData: {
		current: {
			name: string
			description: string
			masterVariant: {
				attributesRaw: Attribute[]
			}
		}
	}
}

const fetchDeliveryOptions = async (accessToken: string, skus: string[], language = "de") => {
	const query = /* GraphQL */ `
		query deliveryOptions($skus: [String!]!, $language: Locale!) {
			products(skus: $skus) {
				results {
					id
					key
					masterData {
						current {
							name(locale: $language)
							description(locale: $language)
							masterVariant {
								attributesRaw(includeNames: ["deliveryTimeWorkdays"]) {
									name
									value
								}
							}
						}
					}
				}
			}
		}
	`

	const data = (await fetchCommerceToolsGraphQLApi(accessToken, query, {
		skus,
		language,
	})) as {
		products: {
			results: CommerceToolsDeliveryOption[]
		}
	}

	const deliveryOptions = data?.products?.results ?? []

	const formattedDeliveryOptions = deliveryOptions.map(formatDeliveryOption)
	return formattedDeliveryOptions
}

export const fetchAllDeliveryOptionBySkuForLineItems = async (
	accessToken: string,
	lineItems: LineItem[],
	language = "de",
) => {
	const skus = getAllDeliveryOptionSkusForLineItems(lineItems)
	const deliveryOptions = await fetchDeliveryOptions(accessToken, skus, language)
	const deliveryOptionsBySku = deliveryOptions.reduce((deliveryOptionsBySku, deliveryOption) => {
		const { sku } = deliveryOption
		return {
			...deliveryOptionsBySku,
			[sku]: deliveryOption,
		}
	}, {})

	return deliveryOptionsBySku
}

export default fetchDeliveryOptions
